var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpense(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1975 15.4324C18.5959 11.8127 16.7229 9.11725 15.0947 7.53404C14.6209 7.07334 14.3841 6.843 13.8607 6.62982C13.3374 6.41663 12.8876 6.41663 11.988 6.41663H10.012C9.11241 6.41663 8.66259 6.41663 8.13928 6.62982C7.61598 6.843 7.37908 7.07334 6.90528 7.53404C5.27708 9.11725 3.40414 11.8127 2.8025 15.4324C2.35485 18.1256 4.83933 20.1666 7.61596 20.1666H14.3841C17.1606 20.1666 19.6452 18.1256 19.1975 15.4324Z",
    stroke: "#423F5A",
    strokeWidth: 1.375,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.65198 4.07267C6.46287 3.79741 6.18875 3.42378 6.75499 3.33859C7.33701 3.25101 7.94136 3.64942 8.53292 3.64123C9.06809 3.63383 9.34073 3.39646 9.63324 3.05756C9.94124 2.7007 10.4182 1.83337 11.0001 1.83337C11.582 1.83337 12.0589 2.7007 12.3669 3.05756C12.6594 3.39646 12.932 3.63383 13.4672 3.64123C14.0588 3.64942 14.6632 3.25101 15.2452 3.33859C15.8114 3.42378 15.5373 3.79741 15.3482 4.07267L14.493 5.31729C14.1273 5.84971 13.9444 6.11592 13.5616 6.26632C13.1789 6.41671 12.6843 6.41671 11.6951 6.41671H10.3051C9.31589 6.41671 8.82126 6.41671 8.43851 6.26632C8.05577 6.11592 7.87287 5.84971 7.50708 5.31729L6.65198 4.07267Z",
    stroke: "#423F5A",
    strokeWidth: 1.375
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpense);
export default __webpack_public_path__ + "static/media/expense.bede01f561e7b590822fff84deb1e8c0.svg";
export { ForwardRef as ReactComponent };